import React from 'react';
import Icon from '../../../components/AppIcon';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

const ServiceFrequencyChart = ({ data = [], loading = false }) => {
  const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg shadow-lg p-3">
          <p className="text-sm font-medium text-foreground mb-1">{payload?.[0]?.name}</p>
          <p className="text-sm text-muted-foreground">
            Clientes: <span className="font-semibold text-foreground">{payload?.[0]?.value}</span>
          </p>
          <p className="text-sm text-muted-foreground">
            Porcentaje: <span className="font-semibold text-foreground">{payload?.[0]?.payload?.percentage?.toFixed(1)}%</span>
          </p>
        </div>
      );
    }
    return null;
  };

  // Calculate percentages
  const totalClients = data?.reduce((sum, item) => sum + item?.count, 0);
  const chartData = data?.map(item => ({
    ...item,
    percentage: totalClients > 0 ? (item?.count / totalClients) * 100 : 0
  }));

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="PieChart" size={24} className="text-accent" />
        <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Patrones de Frecuencia de Servicio
        </h2>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Icon name="Loader2" className="w-8 h-8 text-blue-600 animate-spin" />
        </div>
      ) : chartData?.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-64">
          <Icon name="PieChart" size={48} className="text-muted-foreground mb-2" />
          <p className="text-sm caption text-muted-foreground">
            No hay datos de frecuencia disponibles
          </p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percentage }) => `${name}: ${percentage?.toFixed(0)}%`}
              outerRadius={100}
              fill="#8884d8"
              dataKey="count"
            >
              {chartData?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: '14px' }} />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default ServiceFrequencyChart;